export default "__VITE_ASSET__5sYuhxdJ__"